import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store/index'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/content',
    name: 'content',
    component: () => import('@/views/Layout/index.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home/index.vue'),
      },
      {
        path: '/affliate_list',
        name: 'affliate_list',
        component: () => import('@/views/Offers/affliate_list.vue'),
      },
      {
        path: '/track_link',
        name: 'track_link',
        component: () => import('@/views/Offers/track_link.vue'),
      },
      {
        path: '/all_offers',
        name: 'all_offers',
        component: () => import('@/views/Offers/all_offers.vue'),
      },
      {
        path: '/finance_method',
        name: 'finance_method',
        component: () => import('@/views/Finance/finance_method.vue'),
      },
      {
        path: '/finance_list',
        name: 'finance_list',
        component: () => import('@/views/Finance/finance_list.vue'),
      },
      // Report
      {
        path: '/order_list',
        name: 'order_list',
        component: () => import('@/views/Order/order_list.vue'),
      },
      {
        path: '/daily_report',
        name: 'daily_report',
        component: () => import('@/views/Order/daily_report.vue'),
      },
      {
        path: '/offer_report',
        name: 'offer_report',
        component: () => import('@/views/Order/offer_report.vue'),
      },
      // Account
      {
        path: '/personal',
        name: 'personal',
        component: () => import('@/views/Account/personal.vue'),
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/Account/feedback.vue'),
      },
      {
        // 路由重定向
        path: '/',
        redirect: {
          path: '/home',
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue')
  },
  {
    path: '/wait',
    name: 'wait',
    component: () => import('@/views/wait.vue')
  },
  {
    path: '/clause',
    name: 'clause',
    component: () => import('@/views/clause.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/privacy-policy.vue')
  },
  // 404 页面
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import('@/views/404.vue')
  },
  {
    // 路由重定向
    path: '/',
    redirect: {
      path: '/home',
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {

  if (to.path !== '/login' && to.path !== '/wait' && to.path !== '/privacy-policy' && to.path !== '/clause' && !store.state.access_token) {
    next('/login');
  } else {
    next(); // 正常跳转
  }

});

export default router
